var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "fit-content", scrollable: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "ma-0 activator-btn",
                    attrs: {
                      flat: "",
                      icon: "",
                      absolute: "",
                      right: "",
                      large: "",
                      color: "primary",
                      title: "Documentation"
                    }
                  },
                  on
                ),
                [_c("v-icon", { attrs: { large: "" } }, [_vm._v("info")])],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("div", {
        directives: [
          {
            name: "shortkey",
            rawName: "v-shortkey",
            value: ["esc"],
            expression: "['esc']"
          }
        ],
        on: {
          shortkey: function($event) {
            _vm.dialog = false
          }
        }
      }),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "background" },
        [
          _c(
            "v-card-title",
            { staticClass: "py-1 background darken-1" },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("info")]),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2 headline" }, [
                _vm._v(
                  "\n\t\t\t\tDocumentation de l'explorateur de fichiers\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      _vm.dialog = false
                    }
                  }
                },
                [_c("v-icon", { attrs: { large: "" } }, [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                { staticClass: "pa-0", attrs: { "grid-list-xl": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs8: "" } }, [
                        _c(
                          "div",
                          { staticClass: "headline primary--text mb-2" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tChamps de recherche\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tPoints de montage\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "content-section" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tPermet d'auto-remplir le champ "
                            ),
                            _c("strong", [_vm._v("chemin")]),
                            _vm._v(
                              " avec\n\t\t\t\t\t\t\tles chemins racine des serveurs de stockage listés.\n\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\tLes boutons\n\t\t\t\t\t\t\t"
                            ),
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: "cyan accent-4" } },
                              [_vm._v("star")]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t\t\tpermettent d'ajouter la racine d'un serveur aux favoris.\n\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\tSi un stockage est manquant dans la liste,\n\t\t\t\t\t\t\til est toujours possible de tenter de saisir son chemin\n\t\t\t\t\t\t\tmanuellement dans le champ "
                            ),
                            _c("strong", [_vm._v("chemin")]),
                            _vm._v(".\n\t\t\t\t\t\t\t"),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\tAu besoin vous pouvez faire une demande à\n\t\t\t\t\t\t\t"
                            ),
                            _c(
                              "a",
                              { attrs: { href: _vm.mailto, target: "_blank" } },
                              [_vm._v("l'équipe de developpement")]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t\t\tpour que votre serveur soit ajouté à la liste des points de\n\t\t\t\t\t\t\tmontage.\n\t\t\t\t\t\t"
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v("\n\t\t\t\t\t\t\tChemin\n\t\t\t\t\t\t")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tEmplacement du chemin en cours, plusieurs fonctionnalités :\n\t\t\t\t\t\t\t"
                          ),
                          _c("table", { staticClass: "icon-list" }, [
                            _c("tr", [
                              _c(
                                "th",
                                [_c("v-icon", [_vm._v("mode_edit")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\tSaisie manuelle du chemin.\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "cyan accent-4" } },
                                    [_vm._v("star")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\tSelection d'un chemin dans la liste de vos favoris.\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_c("v-icon", [_vm._v("history")])], 1),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\tSelection d'un chemin dans la liste des 10 derniers\n\t\t\t\t\t\t\t\t\t\tchemins parcourus.\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [_c("v-icon", [_vm._v("chevron_left")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\tLe bouton à gauche du champ permet de remonter d'un\n\t\t\t\t\t\t\t\t\t\tniveau dans l'arborescence en cours.\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v("\n\t\t\t\t\t\t\tFiltrer\n\t\t\t\t\t\t")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tPermet de filtrer la liste des dossiers et fichiers visibles.\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\tIl filtre unqiuement ce qui est visible dans le tableau,\n\t\t\t\t\t\t\til ne recherchera pas dans les sous dossiers non dépliés.\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "headline primary--text mt-3" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tFonctionnalités de l'explorateur\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v("\n\t\t\t\t\t\t\tTri\n\t\t\t\t\t\t")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tEn cliquant sur les entêtes du tableau,\n\t\t\t\t\t\t\til est possible de trier le tableau par :\n\t\t\t\t\t\t\t"
                          ),
                          _c("ul", [
                            _c("li", [_vm._v("Nom")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Poids")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Date de modification")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v("\n\t\t\t\t\t\t\tNavigation\n\t\t\t\t\t\t")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tDeux façons de naviguer sont possibles :\n\t\t\t\t\t\t\t"
                          ),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tExploration de l'arborescence d'un dossier\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("i", [
                                _vm._v("(le champ "),
                                _c("strong", [_vm._v("chemin")]),
                                _vm._v(" reste inchangé)")
                              ]),
                              _vm._v(" :\n\t\t\t\t\t\t\t\t\t"),
                              _c("ul", [
                                _c("li", [
                                  _vm._v("Au clic sur l'icon de dossier")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v("Au double-clic sur le nom du dossier")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tNavigation vers le contenu d'un dossier\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("i", [
                                _vm._v("(le champ "),
                                _c("strong", [_vm._v("chemin")]),
                                _vm._v(" est mis à jour)")
                              ]),
                              _vm._v(" :\n\t\t\t\t\t\t\t\t\t"),
                              _c("ul", [
                                _c(
                                  "li",
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t\tAu control + clic sur le nom du dossier,\n\t\t\t\t\t\t\t\t\t\t\t("
                                    ),
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("keyboard_command_key")
                                    ]),
                                    _vm._v(
                                      " + click sous MAC)\n\t\t\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t\tAu clic-droit\n\t\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c("strong", [
                                    _vm._v("Naviguez vers //xxx/xx/xxx")
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\tDe plus, à chaque navigation,\n\t\t\t\t\t\t\tl'URL de votre navigateur est mise à jour.\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\tL'URL peut donc être partagée, et copiable dans un email.\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tActions possible\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _c("table", { staticClass: "icon-list" }, [
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "pink lighten-4" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tcheck_box\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "pink--text text--lighten-4" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tSélectionner / Désélectionnner un élément.\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "green accent-3" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tcontent_copy\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "green--text text--accent-3" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tCopier dans le presse papier le chemin de l'élément.\n\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c("i", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t\tSi vous etes sous Windows le chemin sera de type UNC,\n\t\t\t\t\t\t\t\t\t\t\tsinon du type Maestro.\n\t\t\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white lighten-1" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tfolder\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "white--text text--lighten-1" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tOuvrir l'élément dans votre navigateur Windows\n\t\t\t\t\t\t\t\t\t\tvia le "
                                  ),
                                  _c("strong", [_vm._v("FileOpener")]),
                                  _vm._v(".\n\t\t\t\t\t\t\t\t\t")
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "light-blue accent-2" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tvideo_settings\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "light-blue--text text--accent-2"
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tLancer un probe du fichier\n\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c("i", [
                                    _vm._v("(seulement pour les fichiers)")
                                  ]),
                                  _vm._v(".\n\t\t\t\t\t\t\t\t\t")
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "orange accent-2" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tfind_in_page\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "orange--text text--accent-2" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tVisualiser le contenu d'un fichier léger\n\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c("i", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t\tPeut être utile pour de petit documents\n\t\t\t\t\t\t\t\t\t\t\t(txt, json, avs etc...).\n\t\t\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "cyan accent-4" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tstar\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "cyan--text text--accent-4" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tAjouter un élément à vos favoris,\n\t\t\t\t\t\t\t\t\t\tpermet de rappeler un chemin utilisé souvent\n\t\t\t\t\t\t\t\t\t\tvia le selecteur de "
                                  ),
                                  _c("strong", [_vm._v("chemin")]),
                                  _vm._v(".\n\t\t\t\t\t\t\t\t\t")
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tplay_arrow\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "primary--text" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\tLancer une demande travail Maestro.\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "deep-purple lighten-4" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tarrow_forward\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "deep-purple--text text--lighten-4"
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tNaviguer vers le chemin du dossier.\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "th",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "orange accent-2" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "orange--text text--accent-2" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tTélécharger un csv listant le contenu du chemin en cours.\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs4: "" } }, [
                        _c(
                          "div",
                          { staticClass: "headline primary--text mb-3" },
                          [_vm._v("Raccourcis clavier")]
                        ),
                        _vm._v(" "),
                        _c("table", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "keyboard-sc elevation-8" },
                              [
                                _vm.$OS === "MacOS"
                                  ? _c(
                                      "div",
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("keyboard_command_key")
                                        ]),
                                        _vm._v(" + "),
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("arrow_back")
                                        ])
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _vm._v("\n\t\t\t\t\t\t\t\t\t\tCtrl + "),
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("arrow_back")
                                        ])
                                      ],
                                      1
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tRemonter d'un niveau dans l'arborescence en cours.\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "keyboard-sc elevation-8" },
                              [
                                _vm.$OS === "MacOS"
                                  ? _c(
                                      "div",
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("keyboard_command_key")
                                        ]),
                                        _vm._v(" + "),
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("arrow_upward")
                                        ])
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _vm._v("\n\t\t\t\t\t\t\t\t\t\tCtrl + "),
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("arrow_upward")
                                        ])
                                      ],
                                      1
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tRemonter à la racine de l'arborescence en cours.\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "keyboard-sc elevation-8" },
                              [
                                _vm.$OS === "MacOS"
                                  ? _c(
                                      "div",
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("keyboard_command_key")
                                        ]),
                                        _vm._v(" + Clic\n\t\t\t\t\t\t\t\t\t")
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("Ctrl + Clic")])
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tSur un dossier, navigue vers le dossier cliqué.\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "keyboard-sc elevation-8" },
                              [
                                _vm.$OS === "MacOS"
                                  ? _c(
                                      "div",
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("keyboard_option_key")
                                        ]),
                                        _vm._v(" + F\n\t\t\t\t\t\t\t\t\t")
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\tAlt + F\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tMettre le focus sur le champ "
                              ),
                              _c("strong", [_vm._v("Filtrer")]),
                              _vm._v(".\n\t\t\t\t\t\t\t\t")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "headline primary--text mb-3 mt-3" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tUploader de fichiers\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tPour uploader un ou plusieurs fichiers, voici la marche à suivre :\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _c("ol", [
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tNaviguer vers le dossier ou vous voulez déposer des fichiers.\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t(Le chemin dans la barre du haut doit bien etre le chemin du dossier.)\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tGlissez-déposez vos fichiers sur l'explorateur de gravity\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tUne boite de dialogue s'ouvrira pour lancer les uploads.\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t(Les uploads seront possible si les fichiers respectent certaines conditions.)\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tConditions à l'upload d'un fichier :\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tPoids du fichier < " +
                                  _vm._s(
                                    Math.round(
                                      _vm.uploader_max_file_size / 1024
                                    )
                                  ) +
                                  " Mo\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\tLe chemin de destination doit se trouver dans les\n\t\t\t\t\t\t\t\t\tarborescences suivantes :\n\t\t\t\t\t\t\t\t\t"
                                ),
                                _vm._l(
                                  _vm.uploader_valid_destination_paths,
                                  function(item, i) {
                                    return _c(
                                      "div",
                                      { key: "path_" + i },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("folder")
                                        ]),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(item.path) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ],
                                      1
                                    )
                                  }
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\tLes extensions autorisées sont :\n\t\t\t\t\t\t\t\t\t"
                                ),
                                _vm._l(
                                  _vm.uploader_allowed_extensions,
                                  function(ext, i) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: ext + i,
                                        attrs: {
                                          label: "",
                                          small: "",
                                          color: "background darken-1"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(ext) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "headline primary--text mb-3 mt-3" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tCréation de dossier\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tPour créer un dossier, voici la marche à suivre :\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-section" }, [
                          _c("ol", [
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tNaviguer vers le dossier ou vous voulez déposer des fichiers.\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                '\n\t\t\t\t\t\t\t\t\tAu clic droit,\n\t\t\t\t\t\t\t\t\tsi le chemin en cours permet la création de dossier,\n\t\t\t\t\t\t\t\t\tun bouton "Créer un nouveau dossier"\n\t\t\t\t\t\t\t\t\tsera disponible dans le menu contextuel.\n\t\t\t\t\t\t\t\t'
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\tUne boite de dialogue s'ouvrira pour nommer le dossier\n\t\t\t\t\t\t\t\t\tet lancer la création du dossier\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subheading sub-titles" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\tLa création de dossier n'est possible que dans les\n\t\t\t\t\t\t\tarborescences suivantes :\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "content-section" },
                          _vm._l(_vm.uploader_valid_destination_paths, function(
                            item,
                            i
                          ) {
                            return _c(
                              "div",
                              { key: "path_" + i },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("folder")
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(item.path) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cdee46c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cdee46c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/filesystem/explorer_documentation.vue
// module id = null
// module chunks = 